import { Flex, NumberInput } from "@gravity-ui/uikit";
import { Control, Controller } from "react-hook-form";

import { ProductFilters } from "../../ProductFilters";

export interface PriceRangeInputsProps {
  control: Control<ProductFilters>;
  minPlaceholder?: string;
  maxPlaceholder?: string;
  onCommit: () => void;
}

interface PriceInputProps {
  name: "priceFrom" | "priceTo";
  control: Control<ProductFilters>;
  placeholder?: string;
  onCommit: () => void;
}

const PriceInput = ({
  name,
  control,
  placeholder,
  onCommit,
}: PriceInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <NumberInput
            placeholder={placeholder}
            hiddenControls
            {...field}
            value={field.value ?? null}
            onBlur={() => {
              field.onBlur();
              onCommit();
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                onCommit();
              }
            }}
          />
        );
      }}
    />
  );
};

export const PriceRangeInputs = ({
  control,
  minPlaceholder,
  maxPlaceholder,
  onCommit,
}: PriceRangeInputsProps) => {
  return (
    <Flex direction={"column"} gap={2}>
      <PriceInput
        name="priceFrom"
        control={control}
        placeholder={minPlaceholder}
        onCommit={onCommit}
      />
      <PriceInput
        name="priceTo"
        control={control}
        placeholder={maxPlaceholder}
        onCommit={onCommit}
      />
    </Flex>
  );
};
